import axios from "axios";
import { create } from "zustand";

const productRating = create((set) => ({
  allRating: null,
  isLoading: true,
  isCreateLoading: false,

  fetchAllRating: async () => {
    try {
      // Fetch rating
      const res = await axios.get("/fetch-all-product-rating");

      // set rating to state
      if (res.data.productRating.length) {
        set({ allRating: res.data.productRating });
      } else {
        set({ allRating: null });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },
  createRating: async ({ productID, rating, review, username, created_at }) => {
    set({ isCreateLoading: true });
    try {
      // Fetch rating
      const res = await axios.post("/create-product-rating", {
        productID,
        rating,
        review,
        username,
        created_at,
      });

      // set rating to state
      if (res.status === 201) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
    } finally {
      set({ isCreateLoading: false });
    }
  },
}));

export default productRating;
